(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.agent:mxJournal
	 * @module mx.agent
	 * @restrict 'E'
	 * @description
	 * The mxJournal control provides simple journal functionality.
	 *
	 * The example below demonstrates some of the attributes you may use with the Journal control:
	 * @param {string} itemsPerPage@ - How many items should be shown at once
	 * @param {string} currentUserId@ - current user identifier
	 * @param {string} currentUserPhoto@ - current user avatar image
	 * @param {expression} onGetData& - Callback function to load journal items
	 * @param {expression} onAdd& - Callback function to add new comment
	 * @param {expression} attachFilesHandler& - if set then files attaching functionality will be enabled.
	 *            It expects a function that returns a promise,
	 *            result of which is an array of file objects that have at least a key "DisplayString".
	 *            Example: [
	 *                {DisplayString: "file1.txt", url: "path/to/file/file1.txt"},
	 *                {DisplayString: "file2.pdf", url: "path/to/file/file2.pdf"},
	 *                ...
	 *            ];
	 * @param {boolean} readOnly=? - The readOnly property sets or returns whether the contents of a mxTextBox should be read-only.
	 *
	 * @usage
	 *  <mx-journal
	 *      on-add="vm.addComment()"
	 *      on-get-data="vm.getData()"
	 *      read-only="false"
	 *      data-disabled="true"
	 *      current-user-id="12345"
	 *      items-per-page="5">
	 *  </mx-journal>
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxJournal', {
		bindings: {
			itemsPerPage: '@',
			onGetData: '&',
			onAdd: '&',
			onUpdate: '&',
			attachFilesHandler: '&',
			currentUserId: '@',
			currentUserPhoto: '@',
			readOnly: '<',
			showCheckboxes: '=',
		},
		require: {
			mxForm: '?^mxForm',
			mxContainerCtrl: '?^^mxContainer',
		},
		controller: MxJournalCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-journal/mx-journal.html',
	});

	MxJournalCtrl.$inject = ['$q', '$timeout', '$scope', '$element', 'mx.internationalization'];

	function MxJournalCtrl($q, $timeout, $scope, $element, i18n) {
		const vm = this;
		let itemsPerPage;

		vm.$onInit = function () {
			vm.processingItems = false;
			vm.canLoadMore = false;
			vm._showRichEditor = false;

			itemsPerPage = vm.itemsPerPage ? parseInt(vm.itemsPerPage, 10) : 10;

			vm.loadMoreItems = loadMoreItems;
			vm.toggleItem = toggleItem;
			vm.toggleAll = toggleAll;
			vm.toggleAllState = false;

			vm.newComment = '';
			vm.addComment = addComment;

			vm._attachingInProgress = false;
			vm._useFileAttachments = !!$($element).attr('attach-files-handler');
			vm.attachments = [];
			vm.attachFiles = attachFiles;
			vm._handleRichTextBoxBlur = _handleRichTextBoxBlur;
			vm.readOnly = !!vm.readOnly;
			vm.ignoreReadonly = !vm.readOnly;

			vm.items = [];

			vm.onFullscreenToggle = onFullscreenToggle;

			reload();

			if (vm.showCheckboxes) {
				vm.checkboxLabel = _getValueByKey('visibleInPortal');

				$scope.$watch(
					'vm.items',
					function (updata, oldata) {
						if (updata.length !== oldata.length) {
							return false;
						}
						const updatedItems = updata.filter(function (upitem) {
							return (
								oldata.filter(function (olditem) {
									return upitem.entryId === olditem.entryId && upitem.visibleInPortal !== olditem.visibleInPortal;
								}).length > 0
							);
						});
						updatedItems.forEach(function (item) {
							$q.when(
								vm.onUpdate({
									entryId: item.entryId,
									visibleInPortal: item.visibleInPortal,
								})
							);
						});
					},
					true
				);
			}

			if (vm.mxContainerCtrl) {
				vm.mxContainerCtrl.registerChild($scope);
			}
		};

		return vm;

		function reload() {
			vm.newComment = '';
			vm.attachments = [];
			getJournalEntries(true);
		}

		function finishProcessingItems() {
			vm.processingItems = false;
		}

		function loadMoreItems() {
			if (vm.processingItems || !vm.canLoadMore) {
				return;
			}
			getJournalEntries(false);
		}

		function toggleAll() {
			vm.items.forEach(function (item) {
				item.displayItem = vm.toggleAllState;
			});
		}

		function toggleItem(entry) {
			entry.displayItem = !entry.displayItem;
		}

		function getJournalEntries(reload) {
			vm.canLoadMore = false;
			vm.processingItems = true;
			let start = 0;
			if (!reload) {
				start = vm.items.length;
			}
			$q.when(vm.onGetData({ start: start, count: itemsPerPage + 1 }))
				.then(function (data) {
					data = data || [];
					const moreItemsExists = data.length === itemsPerPage + 1;
					if (moreItemsExists) {
						data.pop();
					}

					data.forEach(function (item) {
						item.__my = item.userId === vm.currentUserId;
						item.__created = new Date(item.created);
					});
					let items;
					if (reload) {
						items = data;
					} else {
						items = vm.items;
						for (let i = 0; i < data.length; i++) {
							items.push(data[i]);
						}
					}
					if (items && items.length) {
						items.forEach(function (item) {
							item.__my = item.userId === vm.currentUserId;
							if (vm.toggleAllState) {
								item.displayItem = true;
							}
						});
						//automatically expand first item on initial load
						//and keep user changes
						if (typeof items[0].displayItem === 'undefined') {
							items[0].displayItem = true;
						}
						vm.items = items;

						$timeout(function () {
							addCheckboxesToFormDirtyIgnoredList();
						});
					}
					vm.canLoadMore = moreItemsExists;
				})
				.finally(function () {
					finishProcessingItems();
				});
		}

		function addCheckboxesToFormDirtyIgnoredList() {
			if (vm.mxForm && typeof vm.mxForm.addDirtyIgnoredControls === 'function' && Array.isArray(vm.items)) {
				const checkboxNames = vm.items.map((item, index) => `journal-checkbox${index}_int`);
				vm.mxForm.addDirtyIgnoredControls(checkboxNames);
			}
		}

		function addComment() {
			if (!vm.newComment && vm.attachments.length === 0) {
				return;
			}
			vm.adding = true;
			vm.isFullscreenModeEnabled = false;

			$q.when(
				vm.onAdd({
					text: vm.newComment,
					attachments: vm.attachments,
				})
			)
				.then(
					function () {
						reload();
						$timeout(function () {
							vm._showRichEditor = false;
						}, 100);
					},
					function (error) {
						alert(i18n.get('solutionBuilderAgent.components.journal.adding_error') + (error && error.statusText ? `: ${error.statusText}` : ''));
					}
				)
				.finally(function () {
					vm.adding = false;
				});
		}

		function attachFiles() {
			vm._attachingInProgress = true;
			$q.when(vm.attachFilesHandler())
				.then(function (result) {
					const fileNames = vm.attachments.map((file) => file.DisplayString);
					result.selectedObjects.forEach(function (file) {
						if (fileNames.indexOf(file.DisplayString) === -1) {
							vm.attachments.push(file);
							vm.mxForm.setDirty();
						}
					});
				})
				.catch(mx.logCatch)
				.finally(function () {
					vm._attachingInProgress = false;
				});
		}

		function onFullscreenToggle(isFullscreenModeEnabled, realParentContainer, fullscreenContainer) {
			vm.isFullscreenModeEnabled = isFullscreenModeEnabled;
			const addBtnClassName = '.journal-item--new__content-button';
			const addBtnFullscreenClassName = 'journal-item--new__content-button-fullscreen';
			const addBtnContainer = $(realParentContainer).closest('.journal-item--new__content-container');
			if (isFullscreenModeEnabled) {
				const addBtn = addBtnContainer.find(addBtnClassName);
				$(fullscreenContainer).append(addBtn);
				addBtn.addClass(addBtnFullscreenClassName);
			} else {
				const addBtn = $(fullscreenContainer).find(addBtnClassName);
				addBtnContainer.append(addBtn);
				addBtn.removeClass(addBtnFullscreenClassName);
			}
		}

		function _handleRichTextBoxBlur() {
			$timeout(function () {
				vm._showRichEditor = vm.newComment !== '' || vm.attachments.length > 0 || vm._attachingInProgress || vm.isFullscreenModeEnabled;
			}, 200);
		}

		function _getValueByKey(key) {
			let result = '';
			if (vm.showCheckboxes) {
				const keyValues = vm.showCheckboxes.filter(function (item) {
					return item.key === key;
				});
				if (keyValues && keyValues.length > 0) {
					result = keyValues[0].title;
				}
			}
			return result;
		}
	}
})();
